import React, { FunctionComponent } from "react";
import styles from "./CountriesOverlay.module.scss";
import CountriesOverlayContent from "./CountriesOverlayContent.model";

import getCulturesList from "./helpers/getCulturesList";

import combineClasses from "helpers/combine-classes";
import relativeUrl from "helpers/relativeUrl";

const CountriesOverlay: FunctionComponent<CountriesOverlayContent> = (props) => {
    const cultures = getCulturesList(props._hrefLang, props.translations);

    const isActive = (lang: string, styles: any) => {
        if (lang === props._culture) {
            return styles.is_active;
        }

        return undefined;
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                {cultures && cultures.map((culture: any, index: number) => {
                    return (
                        <a key={index} className={combineClasses([styles.link, isActive(culture.lang, styles)])} href={relativeUrl(culture.link)}>{culture.label}</a>
                    );
                })}
            </div>
        </div>
    );
};

export default CountriesOverlay;